module.exports = __webpack_public_path__ + "static/media/map-pin-cluster.9bf77b45.svg";